import React, { useEffect } from 'react';

import { useGetCompanyLicensesQuery } from 'API/Companies';

import * as actions from '../../actions';
import { useDispatch, useSelector } from '../../Hooks';

const LicensesDispatcher: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.company);
  const {
    data: data,
    loading: loading,
    error: error,
  } = useGetCompanyLicensesQuery({
    variables: {
      companyId: companyId || '',
    },
    skip: !companyId,
  });

  useEffect(() => {
    if (loading || error || !data) {
      return;
    }

    dispatch(actions.setLicenses(data.company.licenses));
  }, [data]);

  return null;
};

export default LicensesDispatcher;
